export const resolution = {
  layout: {
    positionHeaderVisible: 70,
    positionHeaderHidden: 0
  },
  detail: {
    positionListEpisodesUp: 0,
    positionListEpisodesDown: 417
  },
  carousel: {
    height: {
      mainMenu: 86,
      home: {
        live: 214
      },
      live: {
        live: 232
      }
    },
    width: {
      home: {
        live: 380
      },
      live: {
        live: 412
      }
    },
    slideMarginStart: {
      mainMenu: 90,
      episodeSelector: 160,
      homeLive: 54
    }
  },
  search: {
    positionNavigation: 255,
    positionNavigationAR: 345
  },
  grid: {
    fullCatalog: {
      columnCount: 5,
      columnWidth: 166,
      itemHeight: 210,
      rowHeight: 263
    },
    brands: {
      columnCount: 3,
      columnWidth: 273,
      itemHeight: 145,
      rowHeight: 198
    },
    columnCountInLogout: {
      columnCount: 4
    },
    search: {
      columnCount: 4,
      columnWidth: 172,
      itemHeight: 220,
      rowHeight: 263
    }
  },
  live: {
    rowHeight: 295
  }
};
